export default __webpack_public_path__ + "media/images/delivery-b65161ca.svg";